<!-- Иконка PersonOutline: сохранённый рисунок из карточки мониторинга. -->
<template>
  <svg
    :width="size"
    :height="size"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="stroke"
    stroke-width="2"
  >
    <path d="M20 21a8 8 0 1 0-16 0" />
    <circle cx="12" cy="7" r="4" />
  </svg>
</template>

<script>
export default {
  name: "PersonOutlineIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
